// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"157":"c1517572","825":"1951b84b","983":"b6dcbf2f"}[chunkId] + ".css";
};